import React from 'react';

import { FeatureFlagsContext, FeatureFlagsContextType } from '@/context/featureFlagsContext';

export function useFeatureFlag(flagKey: string, defaultValue: boolean = false): boolean {
  const context = React.useContext<FeatureFlagsContextType | undefined>(FeatureFlagsContext);

  if (!context) {
    throw new Error('useFeatureFlag must be used within a FeatureFlagsProvider');
  }

  const { getFlag } = context;
  const value = getFlag(flagKey, false);

  if (typeof value === 'boolean') {
    return value;
  }

  console.error(`Flag ${flagKey} is not a boolean`, value);

  return defaultValue;
}
